/* Pack selector, per-mask design pickers, gallery and sticky add-to-cart. */
(function () {
  'use strict';
  var market = document.querySelector('[data-skii-market]');
  if (market) {
    var marketKey = 'skii-us-en-market:' + window.location.hostname;
    try { if (!sessionStorage.getItem(marketKey)) { sessionStorage.setItem(marketKey, '1'); market.querySelector('form').requestSubmit(); } } catch (e) {}
  }

  function init(root) {
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var discounts = JSON.parse(root.dataset.discounts);
    var fmtr = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
    var fmt = function (cents) { return fmtr.format(cents / 100); };

    var state = { pack: 2, designs: [] };
    var packs = root.querySelectorAll('[data-pack]');
    var panel = root.querySelector('[data-panel]');
    var selectsBox = root.querySelector('[data-selects]');
    var errorEl = root.querySelector('[data-error]');
    var sticky = root.querySelector('[data-sticky]');
    var buttons = root.querySelectorAll('[data-atc]');
    var available = variants.filter(function (v) { return v.available; });
    if (!variants.length) { return; }
    var ready = root.dataset.country === 'US' && root.dataset.currency === 'USD' && available.length > 0;
    buttons.forEach(function (b) { b.disabled = !ready; });
    if (!ready) { errorEl.textContent = root.dataset.country !== 'US' || root.dataset.currency !== 'USD' ? 'Select United States / USD to shop.' : 'Temporarily unavailable. Contact us for availability.'; }
    var firstId = (available[0] || variants[0]).id;
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });

    function discountFor(n) { return Number(discounts[n] || 0); }
    function basePrice() { return byId[firstId].price; }

    function subtotal(n) {
      if (n !== state.pack) { return basePrice() * n; }
      return state.designs.reduce(function (sum, id) { return sum + byId[id].price; }, 0);
    }
    function referenceTotal(n) {
      function reference(id) { return Math.max(byId[id].price, Number(byId[id].compare_at_price) || 0); }
      if (n !== state.pack) { return reference(firstId) * n; }
      return state.designs.reduce(function (sum, id) { return sum + reference(id); }, 0);
    }
    function total(n) {
      var percentage = discountFor(n);
      function discounted(price) { return price - Math.floor(price * percentage / 100); }
      if (n !== state.pack) { return discounted(basePrice()) * n; }
      return state.designs.reduce(function (sum, id) { return sum + discounted(byId[id].price); }, 0);
    }

    function renderSelects() {
      while (state.designs.length < state.pack) { state.designs.push(firstId); }
      state.designs.length = state.pack;
      selectsBox.innerHTML = '';
      if (variants.length < 2) { return; }
      state.designs.forEach(function (id, i) {
        var wrap = document.createElement('div');
        wrap.className = 'pack-field';
        var label = document.createElement('label');
        label.textContent = 'Mask ' + (i + 1) + ' — choose your design';
        wrap.appendChild(label);
        var box = document.createElement('div');
        box.className = 'pack-select';
        var img = document.createElement('img');
        img.alt = '';
        var sel = document.createElement('select');
        sel.id = 'skii-design-' + i;
        label.htmlFor = sel.id;
        var groups = {};
        variants.forEach(function (v) {
          var title = v.public_title || v.title;
          var parts = title.split(' — ');
          var family = parts.length > 1 ? parts[0] : 'Designs';
          if (!groups[family]) {
            groups[family] = document.createElement('optgroup');
            groups[family].label = family;
            sel.appendChild(groups[family]);
          }
          var o = document.createElement('option');
          o.value = v.id; o.textContent = parts.length > 1 ? parts.slice(1).join(' — ') : title; o.disabled = !v.available;
          if (v.id === id) { o.selected = true; }
          groups[family].appendChild(o);
        });
        function paint() {
          var v = byId[Number(sel.value)];
          var src = v.featured_image && v.featured_image.src;
          img.style.display = src ? '' : 'none';
          if (src) { img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_80x80$1$2'); }
        }
        sel.addEventListener('change', function () {
          state.designs[i] = Number(sel.value); paint(); showMedia(byId[state.designs[i]]); render(false);
        });
        paint();
        box.appendChild(img); box.appendChild(sel); wrap.appendChild(box); selectsBox.appendChild(wrap);
      });
    }

    function showMedia(v) {
      var mid = v && v.featured_media && v.featured_media.id;
      if (!mid) { return; }
      var t = root.querySelector('[data-thumb][data-media-id="' + mid + '"]');
      if (t) { t.click(); }
    }

    function render(rebuild) {
      if (rebuild) { renderSelects(); }
      packs.forEach(function (el) {
        var n = Number(el.dataset.pack);
        var active = n === state.pack;
        el.classList.toggle('is-active', active);
        var base = referenceTotal(n);
        var tot = total(n);
        el.querySelector('[data-per]').textContent = fmt(Math.round(tot / n));
        el.querySelector('[data-total]').textContent = fmt(tot);
        var cmp = el.querySelector('[data-compare]');
        if (cmp) { cmp.hidden = tot >= base; cmp.querySelector('s').textContent = fmt(base); cmp.querySelector('em').textContent = 'Save ' + fmt(base - tot); }
        if (active) { el.appendChild(panel); }
      });
      var t = total(state.pack);
      root.querySelectorAll('[data-sticky-pack]').forEach(function (e) { e.textContent = state.pack + (state.pack === 1 ? ' mask' : ' masks'); });
      root.querySelectorAll('[data-sticky-total]').forEach(function (e) { e.textContent = fmt(t); });
    }

    packs.forEach(function (el) {
      el.querySelector('input').addEventListener('change', function () {
        state.pack = Number(el.dataset.pack); render(true);
      });
    });

    function addToCart() {
      if (!ready) { return; }
      errorEl.textContent = '';
      var counts = {};
      state.designs.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      root.querySelectorAll('[data-extra]:checked').forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
      buttons.forEach(function (b) { b.disabled = true; });
      fetch(root.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.d.description || res.d.message || 'Could not add to cart.'); }
          window.location.href = root.dataset.cartUrl;
        })
        .catch(function (e) { errorEl.textContent = e.message; buttons.forEach(function (b) { b.disabled = false; }); });
    }
    buttons.forEach(function (b) { b.addEventListener('click', addToCart); });

    // Gallery thumbnails
    var main = root.querySelector('[data-gallery-img]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active'); if (main) { main.src = t.dataset.src; main.alt = t.dataset.alt || ''; }
      });
    });

    // Sticky bar shows once the main button leaves the viewport
    var mainBtn = root.querySelector('[data-atc-main]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(mainBtn);
    }

    render(true);
  }

  document.querySelectorAll('[data-pdp]').forEach(init);
})();
